import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getPensionHistory } from '../../services/dashboard'
import { getLogger } from '../../core/debuggers'

const logger = getLogger('PensionHistory.slice.js')

const initialState = {
  history: [],
  loading: false,
  error: null,
  status: 'idle',
}

export const onGetPensionHistoryAsync = createAsyncThunk(
  'pensionHistory/getHistory',
  async (_, { getState, rejectWithValue }) => {
    try {
      const state = getState()
      const userId = state.adminAuth.user?.id
      if (!userId) return rejectWithValue('User not authenticated')
      return await getPensionHistory({ userId })
    } catch (error) {
      logger.error(error)
      return rejectWithValue(error.message)
    }
  }
)

const pensionHistorySlice = createSlice({
  name: 'pensionHistory',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(onGetPensionHistoryAsync.pending, (state) => {
        state.loading = true
        state.error = null
        state.status = 'loading'
      })
      .addCase(onGetPensionHistoryAsync.fulfilled, (state, action) => {
        state.loading = false
        state.history = action.payload || []
        state.status = 'succeeded'
      })
      .addCase(onGetPensionHistoryAsync.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload || action.error.message
        state.status = 'failed'
      })
  },
})

export default pensionHistorySlice.reducer
